<div class="p-3">
    <div class="col-12 col-md-3">
        <h3>Domain Management Form</h3>
        <hr class="mb-3"/>
        <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
            <div class="mb-3">
                <label for="domain" class="form-label">Domain <em>*</em></label>
                <input type="text" class="form-control" id="domain" name="domain" #domain="ngModel" [(ngModel)]="data.domain" required>
            </div>
            <div class="mb-3">
                <label for="referral_code" class="form-label">Referral Code</label>
                <ng-select [multiple]="false" [searchable]="true" [(ngModel)]="data.referral_code">
                    <ng-option [value]="player.code" *ngFor="let player of players">{{player.code}} - {{player.name}} ({{player.mobile}})</ng-option>
                </ng-select>
                <div class="mt-2">
                    <p class="text-muted mb-2">You could select referral that bind to this domain. If the user is come from referral link, the referral code from referral link will be used, else the domain's referral code will be used.</p>
                    <p class="text-muted mb-2">您可以绑定一个推荐码到此域名。如果用户通过推荐链接访问，将使用推荐链接的推荐码，否则使用域名的推荐码。</p>
                </div>
            </div>
            <div class="mb-3">
                <label for="ip_address" class="form-label">IP Address <em>*</em></label>
                <select class="form-control" id="ip_address" name="ip_address" #ip_address="ngModel" [(ngModel)]="data.ip_address" required>
                    <option [value]="ip_addresse.ip" *ngFor="let ip_addresse of ip_addresses">PUBLIC IP: {{ip_addresse.ip}}</option>
                </select>
            </div>
            <div class="card mb-3">
                <div class="card-body">
                    <h2 class="mb-1">
                        Point your domain to this server ip, please take note that there are domain progoration period of 24 hours after you setup the domain. <br/>
                        <small class="text-muted">请将您的域名解析到此服务器 IP，请注意域名解析需要24小时才能生效。</small>
                    </h2>
                    <span class="badge bg-primary badge-pill badge-lg fw-bold fs-1 mb-1">{{data.ip_address}}</span>
                    <p>
                        You are required to point your domain to this server ip to ensure the domain is working properly.<br/>
                        <span class="text-muted">您需要将您的域名解析到此服务器 IP，以确保域名能够正常工作。</span>
                    </p>
                    <p>
                        If you are not sure how to point your domain to this server ip, please contact your domain registrar and ask them to point your domain to this server ip.<br/>
                        <span class="text-muted">如果您不清楚如何将域名解析到此服务器 IP，请联系您的域名注册商，要求他们将您的域名指向此服务器 IP。</span>
                    </p>
                    <h4 class="mb-0 fw-bold">Example:</h4>
                    <p>Namecheap Domain Pointing Instructions: <br/>
                    <a href="https://www.namecheap.com/support/knowledgebase/article.aspx/9837/46/how-to-connect-a-domain-to-a-server-or-hosting/#viaip" target="_blank">Read More</a></p>
                    <p>Godaddy Domain Pointing Instructions: <br/>
                    <a href="https://pressable.com/knowledgebase/how-to-point-godaddy-dns-records-to-pressable/#:~:text=place%20at%20GoDaddy.-,Log%20into%20your%20GoDaddy%20account%20and%20navigate%20to%20your%20domain,right%20of%20your%20domain%20name.&text=Modify%20the%20existing%20A%20record,one%20of%20your%20Pressable%20IPs.&text=In%20some%20cases%2C%20the%20%E2%80%9Cwww,and%20not%20a%20CNAME%20record." target="_blank">Read More</a></p>
                </div>
            </div>
            <div class="mb-3">
                <label for="own_ssl_certificate" class="form-label">SSL Certificate <em>*</em></label>
                <select class="form-control" id="own_ssl_certificate" name="own_ssl_certificate" #ssl_certificate="ngModel" [(ngModel)]="data.own_ssl_certificate" required>
                    <option [value]="0">Auto Generate SSL Certificate</option>
                    <option [value]="1">Use My Own SSL Certificate</option>
                </select>
            </div>
            <ng-container *ngIf="data.own_ssl_certificate == 1">
                <div class="mb-3">
                    <label for="cert" class="form-label">SSL Certificate <em>*</em></label>
                    <input type="file" class="form-control" id="cert" name="cert" (change)="readSSLFile($event)">
                    <pre class="text-muted p-3 border mt-2" *ngIf="data.cert">SSL Certificate: <br/>{{data.cert}}</pre>
                </div>
                <div class="mb-3">
                    <label for="cert_private" class="form-label">SSL Certificate Private Key <em>*</em></label>
                    <input type="file" class="form-control" id="cert_private" required (change)="readSSLPrivateKeyFile($event)">
                    <pre class="text-muted p-3 border mt-2" *ngIf="data.cert_private">SSL Certificate Private Key: <br/>{{data.cert_private}}</pre>
                </div>
            </ng-container>
            <div class="mb-3">
                <label for="status" class="form-label">Status <em>*</em></label>
                <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                    <option [value]="1">Active</option>
                    <option [value]="0">Disabled</option>
                </select>
            </div>
            <div class="d-flex flex-row justify-content-between">
                <button type="submit" class="btn btn-primary">Submit</button>
                <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</div>